import { useSelector } from 'react-redux'
import { eventsIdSelectors } from '@ucheba/store/events/id'
import { FC } from 'react'
import EventPageFinished from './EventPageFinished'
import EventPageActual from './EventPageActual'
import { useFinishedEvent } from '../../bll'
import { IEventPage } from '../../types'

const EventPage: FC<IEventPage> = (props) => {
  const { pathname, eventsSearchPath, bannerProgramTypes, onClickAction, bannersBlock } =
    props
  const event = useSelector(eventsIdSelectors.entity)

  const isFinished = useFinishedEvent(event?.startAt, event?.endAt)

  if (!event) return null

  if (isFinished) {
    return (
      <EventPageFinished
        {...event}
        pathname={pathname}
        eventsSearchPath={eventsSearchPath}
        bannerProgramTypes={bannerProgramTypes}
        onClickAction={onClickAction}
        bannersBlock={bannersBlock}
      />
    )
  }

  return (
    <EventPageActual
      {...event}
      pathname={pathname}
      eventsSearchPath={eventsSearchPath}
      bannerProgramTypes={bannerProgramTypes}
      onClickAction={onClickAction}
      bannersBlock={bannersBlock}
    />
  )
}

export default EventPage
